import React from "react"

import { connect } from "scrivito"
import { ProductPosition } from "shared/types/ProductPosition"
import { ProductPositionInstallationReference } from "shared/types/__generated__/graphql"

import { InstallationReferenceSelectionOverlay } from "./InstallationReferenceSelectionOverlay"
import { useInstallationReferenceSelectionOverlayModel } from "./model/useInstallationReferenceSelectionOverlayModel"

export interface InstallationReferenceSelectionOverlayPayload {
  productPosition?:
    | Partial<Pick<ProductPosition, "variantKey" | "references">>
    | null
    | undefined
  onSubmit: (
    productPositionInstallationReferences:
      | ProductPositionInstallationReference[]
      | null
  ) => void
}

export interface InstallationReferenceSelectionOverlayConnectorProps {
  payload: InstallationReferenceSelectionOverlayPayload
}

function InstallationReferenceSelectionOverlayConnectorComponent(
  props: InstallationReferenceSelectionOverlayConnectorProps
) {
  return (
    <InstallationReferenceSelectionOverlay
      {...useInstallationReferenceSelectionOverlayModel(props)}
    />
  )
}

export const InstallationReferenceSelectionOverlayConnector = React.memo(
  connect(InstallationReferenceSelectionOverlayConnectorComponent)
) as typeof InstallationReferenceSelectionOverlayConnectorComponent

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    INSTALLATION_REFERENCE_SELECTION_OVERLAY: InstallationReferenceSelectionOverlayPayload
  }
}
